export default __webpack_public_path__ + "static/1809-38d339f0bab8c89a4398750b9680745f.gif";